import styled from "styled-components";
import { Row, Col, Typography } from "antd";
import { MdKeyboardArrowRight } from "react-icons/md";
import { capitalize } from "utils/randomString";

const { Title } = Typography;

// styled components list item
export const ListItem = styled(Row)`
  border-bottom: ${(props) =>
    !props.showBorderBottom ? `1px solid #e8e8e8` : `none`};
  padding: 1em 1.5em;
  cursor: pointer;
  background: ${(props) => (!props.active ? `#F5F5F5` : `#FFFFFF`)};
  &:hover {
    background: #ffffff;
  }
`;
// title of the list
export const ProspectTitle = ({data}) => {
  return (
    <Row justify="space-between" style={{ padding: "1.5em" }}>
      <Col>
        <Title level={5}>Prospects ({data?.length})</Title>
      </Col>
      
    </Row>
  );
};

// list of prospects
export const List = ({ data, handleProspectChange, active }) => {
  
  return  data && data.length > 0 && data.map((item, index) => (
    <ListItem
      key={item?.id}
      showBorderBottom={data.length - 1 === index}
      active={`${active}` === `${item?.id}`}
      onClick={() =>handleProspectChange(item?.id,item?.importer_id) }
    >
      <Col span={24}>
        <Row align="middle" justify="space-between">
          <Col span={16}>
            <Title level={5} ellipsis>{capitalize(item?.name)}</Title>
          </Col>
          <Col>
            <MdKeyboardArrowRight size={24} />
          </Col>
        </Row>
        <Row>
          <Col>
            {" "}
            <Title level={5} type="secondary">
              {" "}
              {capitalize(item?.country)}
            </Title>
          </Col>
        </Row>
      </Col>
    </ListItem>
  ));
};
